import * as React from 'react';
const VeneVaricoseIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <circle cx={94.12} cy={90.33} r={25.81} className="prefix__cls-2" />
    <path
      d="m117.186 123.202 9.44-9.44 13.089 13.088a5.557 5.557 0 0 1 0 7.85l-1.591 1.59a5.557 5.557 0 0 1-7.85 0z"
      className="prefix__cls-2"
    />
    <path
      d="m109.967 110.97 5.226-5.225 9.73 9.73-5.226 5.225zM94.84 62.83c1.36-2.77 2.35-4.33 2.35-4.33"
      className="prefix__cls-2"
    />
    <path
      d="M84.27 107.99c1.51-4.74 2.22-10.28 3.62-21.89.73-6.04 2.23-11.45 3.81-15.84"
      className="prefix__cls-1"
    />
    <path
      d="M95.82 117.83c.09.21.19.43.3.64 2.78 5.37 4.27 11.71-1.39 12.89s-8.97-.32-14.09 5.48c-5.13 5.8-11 4.94-16.55 3.97s-6.41-5.91-2.78-7.84 5.92.24 10.46-6.98c4.06-6.44 6.82-7.51 9.06-10.48"
      className="prefix__cls-2"
    />
    <path
      d="M112.37 81.92c-1.32 5.08-3.56 10.54-6.02 14.3-4.23 6.48-7.56 10.77-9.41 14.14"
      className="prefix__cls-1"
    />
    <path d="M114.31 64s.35 2.72-.08 7.02" className="prefix__cls-2" />
    <path
      d="M92.46 102.58s-1.5-5.28 2.35-10.72c3.85-5.45 7.35-8.93 7.05-12.76"
      className="prefix__cls-1"
    />
    <path d="M100.97 83s-2.71 5.8-1.14 9.97" className="prefix__cls-1" />
  </svg>
);
export default VeneVaricoseIcon;
